import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Grid, CircularProgress, Stack, Paper } from '@mui/material';
import { getAnalyticsSummary } from '../../../../services/contentApiFn';
import PaperContainer from '../../../../components/Containers/PaperContainer';

function AnalyticsDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const res = await getAnalyticsSummary();
      if (res?.data?.status === 'success') {
        setStats(res.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Box p={4} display="flex" justifyContent="center"><CircularProgress /></Box>;
  }

  if (!stats) return <Typography>Failed to load analytics</Typography>;

  const StatCard = ({ title, value, color }) => (
    <Card sx={{ p: 3, borderRadius: 3, borderLeft: `6px solid ${color}`, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
      <Typography variant="subtitle2" color="textSecondary">{title}</Typography>
      <Typography variant="h4" fontWeight="bold" mt={1}>{value}</Typography>
    </Card>
  );

  return (
    <PaperContainer>
      <Box p={2}>
        <Typography variant="h5" fontWeight="bold" mb={3}>Analytics Overview</Typography>
        
        <Typography variant="h6" mb={2} mt={4}>Content Pipeline</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Total Generated" value={stats.totalPosts} color="#2196f3" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Published" value={stats.publishedPosts} color="#4caf50" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Scheduled" value={stats.scheduledPosts} color="#ff9800" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="In Draft" value={stats.draftPosts} color="#9e9e9e" />
          </Grid>
        </Grid>

        <Typography variant="h6" mb={2} mt={5}>Engagement Metrics</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Facebook Likes" value={stats.facebookLikes || 0} color="#1877F2" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Instagram Likes" value={stats.instagramLikes || 0} color="#E4405F" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Email Opens" value={stats.emailOpens || 0} color="#D44638" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Blog Views" value={stats.blogViews || 0} color="#7922D8" />
          </Grid>
        </Grid>
        
        {/* Placeholder for future Charts */}
        <Box mt={5}>
          <Paper sx={{ p: 4, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2 }}>
            <Typography variant="body1" color="textSecondary">
              Interactive engagement charts (Bar/Line) will appear here as more cross-platform data is collected via Webhooks.
            </Typography>
          </Paper>
        </Box>
      </Box>
    </PaperContainer>
  );
}

export default AnalyticsDashboard;
